import React from 'react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { ReviewCard, Stars, VideoReviewCard } from '../components/shared/ReviewCard';
import { CtaBand } from '../components/shared/CtaBand';
import { reviews, videoTestimonials } from '../data/reviews';
import { IMAGES } from '../data/images';
import { SITE } from '../data/site';
export function Reviews() {
  return <>
      <Seo title="Wall of Love — Student Reviews" description="Read reviews from HPP Training students: Las Vegas CCW classes, women’s firearms training and defensive handgun courses." data-id="element-929" data-mp="11dapswuno2t0" />
      <PageHero title="Wall of Love" sub="Real words from real students — beginners, women and experienced shooters." image={IMAGES.students} crumbs={[{
      label: 'Reviews'
    }]} data-id="element-930" data-mp="rfcyu1levrwp">
        <ButtonLink href={SITE.googleReviews} size="lg" newTab data-id="element-931" data-mp="3863bh1rrpv1n">
          Leave a Google Review
        </ButtonLink>
        <ButtonLink href={SITE.facebookReviews} size="lg" variant="outline-light" newTab data-id="element-932" data-mp="2ppvo33yrk0o">
          Review on Facebook
        </ButtonLink>
      </PageHero>

      <section className="gutter section bg-mist" aria-labelledby="wall-title" data-id="element-933" data-mp="3txc2u5pw64ma">
        <div className="flex flex-wrap items-end gap-5" data-id="element-934" data-mp="brh074mrpksy">
          <span className="font-display text-[clamp(4rem,7vw,8rem)] font-bold leading-[0.85] text-navy" data-id="element-935" data-mp="7ou42rj2ddpy">{SITE.googleRating}</span>
          <div className="pb-1" data-id="element-936" data-mp="lntt40ahnumn">
            <Stars className="h-6 w-6" data-id="element-937" data-mp="ln0vboticfgn" />
            <h2 id="wall-title" className="mt-2 font-display text-xl uppercase tracking-[0.12em] text-steel" data-id="element-938" data-mp="gpilzxbkvy84">
              Average rating on Google
            </h2>
          </div>
        </div>
        <div className="mt-12 columns-1 gap-5 sm:columns-2 xl:columns-3 3xl:columns-4 4xl:columns-5 [&>*]:mb-5 [&>*]:break-inside-avoid" data-id="element-939" data-mp="qfbton8lnt73">
          <ReviewCard review={reviews[0]} data-id="element-940" data-mp="14g4rphy416ey" />
          <VideoReviewCard video={videoTestimonials[0]} data-id="element-941" data-mp="14d0c7of72o8z" />
          <ReviewCard review={reviews[1]} data-id="element-942" data-mp="zh1kbqunqo3t" />
          <div className="rounded-[4px] bg-navy p-8" data-id="element-943" data-mp="ze5lm0azjveb">
            <p className="font-display text-3xl font-bold uppercase leading-tight text-white" data-id="element-944" data-mp="3t91c8fs1tgok">“Self-Defense isn’t just a right, it is also a Responsibility.”</p>
            <p className="mt-3 text-sm text-chrome-300" data-id="element-945" data-mp="63iopp2y16zb">— CCW Maggie</p>
          </div>
          <ReviewCard review={reviews[2]} data-id="element-946" data-mp="61frol3didl3" />
          <VideoReviewCard video={videoTestimonials[1]} data-id="element-947" data-mp="av0owax573j8" />
          <div className="rounded-[4px] bg-white p-8 ring-1 ring-navy/10" data-id="element-948" data-mp="ft294z6b18wa">
            <p className="t-h3 text-navy" data-id="element-949" data-mp="fstr6svbrde8">Trained with HPP?</p>
            <p className="mt-2 text-steel" data-id="element-950" data-mp="kr3r1grzv266">Your review helps someone else take their first step toward protecting themselves.</p>
            <div className="mt-6 flex flex-wrap gap-3" data-id="element-951" data-mp="ps163khpjg3g">
              <ButtonLink href={SITE.googleReviews} size="sm" newTab data-id="element-952" data-mp="tt4n4abhri69">
                Leave a Review
              </ButtonLink>
              <ButtonLink href={SITE.facebookReviews} size="sm" variant="outline-dark" newTab data-id="element-953" data-mp="2rk78sl0np35i">
                Facebook
              </ButtonLink>
            </div>
          </div>
        </div>
      </section>
      <CtaBand title="Write Your Own Story." primaryLabel="Book a Class" data-id="element-954" data-mp="2o29v9f1malx3" />
    </>;
}